module.exports = __webpack_public_path__ + "static/media/hello_smiely.03c9b716.svg";